/* eslint-disable import/no-extraneous-dependencies */
import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { enqueueSnackbar } from "notistack";

import { FormButton } from "../../../components/FormButton";
import { Input } from "../../../components/Input";
import { AuthContext } from "../../../contexts/AuthContext";
import { api } from "../../../services/api";
import { PageTitle } from "../../../components/PageTitle";

interface Equipment {
  name: string;
}

const schema = Yup.object().shape({
  name: Yup.string().required("Campo equipamento é obrigatório"),
});

export function EquipmentEdit() {
  const { user } = useContext(AuthContext);
  const { id } = useParams();
  const [equipment, setEquipment] = useState<Equipment>();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      api.get(`equipments/${id}`).then(response => {
        return setEquipment(response.data);
      });
    }
  }, [id]);

  function handleSubmit(data: Equipment) {
    if (id) {
      api
        .put(`/equipments/${id}`, data)
        .then(() => {
          enqueueSnackbar("Equipamento editado com sucesso!", {
            variant: "success",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          });
        })
        .catch(({ response }) => {
          enqueueSnackbar(response.data.message, {
            variant: "warning",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          });
        });
    } else {
      api
        .post("/equipments", data)
        .then(() => {
          enqueueSnackbar("Equipamento cadastrado com sucesso!", {
            variant: "success",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          });
        })
        .catch(({ response }) => {
          enqueueSnackbar(response.data.message, {
            variant: "warning",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          });
        });
    }
    return navigate("/equipments");
  }

  const initialValues = {
    name: equipment ? equipment.name : "",
  };

  return (
    <div className="container mx-auto">
      <PageTitle
        title={id ? "Editar Equipamento" : "Novo Equipamento"}
        backButton
        backPath="/equipments"
      />
      <div className="w-full">
        <div className="bg-white rounded-lg shadow-sm p-6">
          <Formik
            initialValues={initialValues}
            enableReinitialize
            validationSchema={schema}
            onSubmit={values => {
              handleSubmit(values);
            }}
          >
            {({ errors }) => (
              <Form className="space-y-4">
                <div className="space-y-2">
                  <span className="text-sm text-[#0085BD] font-medium">
                    Equipamento
                  </span>
                  <Input
                    type="text"
                    name="name"
                    placeholder="Nome do equipamento"
                    error={errors.name}
                    className="h-[52px] px-4 w-full rounded-lg text-[#7FA5B2] bg-white border border-gray-200 focus:border-[#0085BD] focus:ring-1 focus:ring-[#0085BD]"
                  />
                </div>
                <FormButton
                  title={id ? "Editar Equipamento" : "Cadastrar Equipamento"}
                  type="submit"
                  className="w-full h-[52px] bg-[#0085BD] text-white rounded-lg hover:bg-[#006a96] transition-colors font-medium"
                />
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
}
